var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('page-with-button',{attrs:{"title":"Your meeting is scheduled","subtitle":"You'll get an email reminding you of the date and time","titleDescription":"We look forward to meeting you!","textDescription":`One of our team members will meet with you and explain how the service
      works and how you and your patients can benefit.
      \n•  Test your audio and video before the meeting
      •  Make sure your internet connection has good bandwidth before joining
      \nSee you soon,
      The CareSend Team`,"img":require('@/assets/logo.png'),"icon":"video"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }